import dayjs from "dayjs";
import type { TFunction } from "i18next";

import {
  IIncidentByRideListRowDto,
  IIncidentDto,
  IncidentStatusEnum,
  IRideDto,
  isValidDateTime,
} from "@ryde/shared";

export const getIncidentCreatedAtMsForSort = (
  row: IIncidentByRideListRowDto,
): number => {
  const createdAt = row.createdAt;
  if (!createdAt || !isValidDateTime(createdAt)) {
    return Number.NEGATIVE_INFINITY;
  }
  return dayjs(createdAt).valueOf();
};

export const buildIncidentDraftFromRide = (
  ride: IRideDto,
): Partial<IIncidentDto> => ({
  rideId: ride.id,
  driverId: ride.driverId || undefined,
  companyId: ride.companyId,
  metadata: {},
});

/** Single line for “closed by … at …” on the ride incident mini-card (remarks render below separately). */
export const buildRideIncidentClosedMetaLine = ({
  row,
  formatIncidentClosedAt,
  t,
}: {
  row: IIncidentByRideListRowDto;
  formatIncidentClosedAt: (iso: TDateISO | null | undefined) => string;
  t: TFunction;
}): string => {
  if (row.status !== IncidentStatusEnum.Closed) {
    return "";
  }
  const closedByName = (row.userClosedByName ?? "").trim();
  const closedAtWhen = formatIncidentClosedAt(row.closedAt);
  if (closedByName && closedAtWhen) {
    return t("ride.incidents.closedByAtLine", {
      name: closedByName,
      when: closedAtWhen,
    });
  }
  if (closedByName) {
    return t("ride.incidents.closedByLine", { name: closedByName });
  }
  if (closedAtWhen) {
    return t("ride.incidents.closedAtLine", { when: closedAtWhen });
  }
  return "";
};
